import { render, staticRenderFns } from "./HomeActividades.vue?vue&type=template&id=12980231&scoped=true"
import script from "./HomeActividades.vue?vue&type=script&lang=js"
export * from "./HomeActividades.vue?vue&type=script&lang=js"
import style0 from "./HomeActividades.vue?vue&type=style&index=0&id=12980231&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12980231",
  null
  
)

export default component.exports